import qs from "query-string";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import utils from "@src/utils";

import { updateIpv4 } from "@store/reducers/app";
import { useSelector, useDispatch } from "react-redux";

import graphql from "@src/api/graphql";
import { useMutation } from "@apollo/client";


const Tracking = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const app = useSelector(state => state.app);
  const session = useSelector(state => state.session);

  const [idleInterval, setIdleInterval] = useState(null);

  const [pushActivity] = useMutation(
    graphql.activities.push,
  );

  const reportActivity = (activity) => {
    pushActivity({
      variables: {
        record: {
          company: session.cookie?.alias,
          email: session.cookie?.email,
          ...activity,
        },
      },
    });
  };

  useEffect(async () => {
    const ip = await utils.network.getIp();
    dispatch(updateIpv4(ip));
  }, []);

  useEffect(() => {
    if (process.env.REACT_APP_ENV === "development") {
      return;
    }

    clearInterval(idleInterval);

    reportActivity({
      type: "navigate",
      action: location.pathname,
      details: qs.parse(location.search),
    });

    setIdleInterval(
      setInterval(() => {
        reportActivity({
          type: "idle",
          action: location.pathname,
        });
      }, 5000),
    );
  }, [location.pathname]);

  useEffect(() => {
    if (process.env.REACT_APP_ENV === "development") {
      return;
    }

    if (app.activity) {
      reportActivity(app.activity);
    }
  }, [app.activity]);

  return (
    <div className={props.className}>
      {props.children}
    </div>
  );
};

export default Tracking;
